import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Auth from '../auth';
import { confirmarMfaApi, loginApi, enlazarMfaUsuarioApi, getSeller } from '../api/axios'
import { setAuthenticated, setIdSeller, setUserName, setUserCredenciales, setMfaStatus } from '../actions/generalActios'
import { fetchTokenResetPassword, userTypeIds, postSearchUsuario } from '../actions/usuariosActions';
import { GoogleReCaptcha, withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from '../utilities/appToast';
import { encryptPassword } from '../utilities/encryptPassword';
import './Login.css';

// Wrapper para usar hooks en class component y el Provider de ReCaptcha

class Login extends React.Component {
    constructor(props) {
        super(props);
        //this._SolveReCaptcha = false; //process.env.NODE_ENV === "production"; //desarrollo - no olvidar el appsettings.json que apunta a desarrollo con su score
        this._SolveReCaptcha = true; //produccion - no olvidar el appsettings.json que apunta a produccion con su score
        this.loginStageRef = React.createRef();
        this._exitNavigateTimer = null;
        this.state = {
            user: '',
            email: '',
            password: '',
            errorMessage: '',
            showSpinner: false,
            recoverPassword: false,
            showPassword: false,
            mFaHabilitado: false,
            mfaConfirmado: false,
            showInputMFaHabilitado: false,
            esperandoCodigoDobleAutenticacion: false,
            codigoDobleAutenticacion: "",
            errorCodigoDobleAutenticacion: "",

            // New MFA Flow State
            showMfaPrompt: false,
            showMfaSetup: false,
            codigoQR: null,
            mfaSetupCode: "",
            mfaSetupError: "",
            loginResponseData: null,
            loginExitActive: false,
            loginExitReveal: false,
            sellerLogo: "",
            sellerNombre: "",
        }
    }

    isSellerUserType = (tipoUsuario) =>
        tipoUsuario === userTypeIds.isSellerAdmin || tipoUsuario === userTypeIds.isSeller;

    extractSellerFromResponse = (res) =>
        res?.paginateSellers?.elementos?.[0] ??
        res?.PaginateSellers?.Elementos?.[0] ??
        res?.seller ??
        res?.Seller ??
        null;

    async fetchSellerBranding(idSeller, tipoUsuario, fallbackNombre = "") {
        if (!this.isSellerUserType(tipoUsuario) || !idSeller || Number(idSeller) <= 0) {
            return { sellerLogo: "", sellerNombre: "" };
        }

        try {
            const res = await getSeller(idSeller);
            const seller = this.extractSellerFromResponse(res);
            if (!seller) {
                return { sellerLogo: "", sellerNombre: fallbackNombre || "" };
            }

            const sellerLogo = seller.logo || seller.urlLogo || "";
            const sellerNombre =
                seller.nombreTienda ||
                seller.razonSocial ||
                fallbackNombre ||
                "";

            return { sellerLogo, sellerNombre };
        } catch {
            return { sellerLogo: "", sellerNombre: fallbackNombre || "" };
        }
    }

    componentWillUnmount() {
        if (this._exitNavigateTimer != null) {
            clearTimeout(this._exitNavigateTimer);
            this._exitNavigateTimer = null;
        }
        if (this._exitRevealTimer != null) {
            clearTimeout(this._exitRevealTimer);
            this._exitRevealTimer = null;
        }
    }

    componentDidMount() {
        this.setState({ recoverPassword: false });
    }

    componentDidUpdate(prevProps) {
        const key = this.props.location?.key;
        if (key != null && key !== prevProps.location?.key) {
            this.setState({ recoverPassword: false });
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "codigoDobleAutenticacion") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ codigoDobleAutenticacion: soloNumeros });
        } else if (name === "mfaSetupCode") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ mfaSetupCode: soloNumeros });
        } else {
            this.setState({ [name]: value });
        }
    }

    onRequestToken = (event) => {
        if (event?.preventDefault) event.preventDefault();
        this.setState({ showSpinner: true });

        this.props.fetchTokenResetPassword(this.state.email)
            .then(() => {
                this.setState({ recoverPassword: false });
                toast.success("Se enviará un mail al correo del usuario con un token temporal para que pueda ingresar");
            })
            .catch((err) => {
                const errores = err?.response?.data?.errores || ["No pudo enviarse el token"];
                errores.forEach(error => toast.error(error));
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        if (this.state.recoverPassword) {
            return;
        }
        this.onLogin(e);
    };

    onLogin = async (e) => {
        e.preventDefault();
        if (this.state.submitted) return;

        this.setState({ submitted: true, showSpinner: true });

        let tokenReCaptcha = "";

        if (this._SolveReCaptcha) {
            const executeRecaptcha = this.props.googleReCaptchaProps?.executeRecaptcha;
            if (!executeRecaptcha) {
                this.setState({
                    errorMessage: "El servicio de ReCaptcha no está disponible. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            try {
                tokenReCaptcha = await executeRecaptcha("login");
            } catch (error) {
                console.error("Error executing reCAPTCHA", error);
                this.setState({
                    errorMessage: "Error al validar ReCaptcha. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            if (!tokenReCaptcha) {
                this.setState({
                    errorMessage: "No se pudo obtener el token de ReCaptcha. Intente nuevamente",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }
        }

        const { user, password, codigoDobleAutenticacion } = this.state;

        let requestLogin = {
            Usuario: user,
            Password: encryptPassword(password),
            codigo: codigoDobleAutenticacion,
            idConexion: "string",
            TokenCaptcha: tokenReCaptcha
        }


        let req = loginApi(requestLogin);

        this.props.setUserCredenciales(user, encryptPassword(password))

        req.then(async (res) => {
            const { mfaHabilitado, mfaConfirmado, tipoUsuario, fechaUltimoLogin, mfaBypass } = res;

            this.props.setMfaStatus(mfaHabilitado, mfaConfirmado, this.state.codigoDobleAutenticacion);



            // Si es un usuario que debe resetear password (tipo 5)
            if (tipoUsuario == userTypeIds.isResetPassword) {

                this.completeLogin(res);
                return;
            }

            // Bypass MFA: solo si el BFF marca mfaBypass (SecurityOverrides:MfaBypassUserIds en appsettings)
            if (mfaBypass) {
                this.completeLogin(res);
                return;
            }

            if ((mfaHabilitado === false && mfaConfirmado === false) ||
                (mfaHabilitado === true && mfaConfirmado === false)) {

                // Interceptar inicio de sesión si MFA no está habilitado/confirmado
                this.setState({
                    loginResponseData: res,
                    showMfaPrompt: true,
                    submitted: false,
                    showSpinner: false
                });

            } else if (mfaHabilitado === true && mfaConfirmado === true) {
                this.setState({
                    submitted: false,
                    esperandoCodigoDobleAutenticacion: true,
                    showInputMFaHabilitado: true,
                    showSpinner: false,
                });

                if (this.state.codigoDobleAutenticacion.length === 6) {
                    this.completeLogin(res);
                }
            }


        }).catch(err => {
            let errorMsg = "Error de autenticación";


            if (err?.response?.status === 400 && this.state.esperandoCodigoDobleAutenticacion) {
                errorMsg = "El código de segundo factor de autenticación es inválido";
                this.setState({
                    errorMessage: "",
                    errorCodigoDobleAutenticacion: errorMsg,
                    submitted: false,
                    showSpinner: false,
                    codigoDobleAutenticacion: "",
                });
            } else {
                // Manejo de otros errores
                // Si la API devuelve un array de errores directamente
                if (Array.isArray(err?.response?.data)) {
                    err.response.data.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }
                // Errores del backend como array de strings en propiedad 'errores'
                if (err?.response?.data?.errores) {
                    const errores = err.response.data.errores;
                    errores.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }

                this.setState({
                    errorMessage: "",
                    submitted: false,
                    showSpinner: false,
                });
            }


        });
    }

    completeLogin = async (res) => {
        const { idSeller, nombre, tipoUsuario, userId, hiddenItemsIds, fechaUltimoLogin, mfaConfirmado, mfaHabilitado, canImpersonate } = res;
        let { codProv } = res;

        // Se detecta usuario en proceso de reset si:
        // 1. Es un usuario existente (fechaUltimoLogin).
        // 2. Tiene MFA Confirmado en FALSE.
        // 3. Tiene MFA Habilitado en FALSE (esto lo distingue de usuarios normales pendientes de configurar MFA).
        const isUsuarioExistenteConResetPendiente = mfaHabilitado === false && mfaConfirmado === false && fechaUltimoLogin;

        const isResetPassword = tipoUsuario == userTypeIds.isResetPassword;

        // ID efectivo del usuario — puede ser 0 si el login API no lo devuelve correctamente (ej. Contaduria tipo 8)
        let effectiveUserId = userId;

        // Si estamos en modo reset y el userId vino como 0/vacío, buscar el ID real por username
        if (isResetPassword && (!effectiveUserId || effectiveUserId === 0)) {
            try {
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user || this.state.email });
                const usuarios = userResponse?.data?.usuario ?? userResponse?.data?.Usuario ?? userResponse?.usuario ?? userResponse?.Usuario ?? [];
                if (Array.isArray(usuarios) && usuarios.length > 0) {
                    effectiveUserId = usuarios[0].idUsuario || usuarios[0].IdUsuario || 0;
                }
            } catch (error) {
                // Si falla la búsqueda, continuar con userId=0 y dejar que UserEdit maneje el fallback
            }
        }

        const redirectTo = isResetPassword
            ? `/Usuarios/Editar/${effectiveUserId}`
            : `/`;

        // Si codProv no vino en el login, lo buscamos en el detalle del usuario
        if (!codProv && tipoUsuario !== userTypeIds.isResetPassword) {
            try {
                // Se busca por nombreUsuario como solicitó el usuario
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user });
                const usuarios = userResponse?.data?.usuario ?? userResponse?.data?.Usuario ?? userResponse?.usuario ?? userResponse?.Usuario ?? [];
                if (Array.isArray(usuarios) && usuarios.length > 0) {
                    const userObj = usuarios[0];
                    // Intenta con idProveedor/idProvedor en camel o pascal.
                    codProv = userObj.idProveedor || userObj.IdProveedor || userObj.idProvedor || userObj.IdProvedor;
                }
            } catch (error) {
                // Silently handle error
            }
        }

        Auth.login(idSeller, nombre, tipoUsuario, effectiveUserId, hiddenItemsIds, codProv, null, canImpersonate);

        const sellerBranding = await this.fetchSellerBranding(idSeller, tipoUsuario, nombre);
        this.setState({
            submitted: false,
            showSpinner: false,
            sellerLogo: sellerBranding.sellerLogo,
            sellerNombre: sellerBranding.sellerNombre,
        });

        const runNavigate = () => {
            if (this._exitNavigateTimer != null) {
                clearTimeout(this._exitNavigateTimer);
                this._exitNavigateTimer = null;
            }
            if (isResetPassword) {
                this.props.navigate(redirectTo, {
                    state: {
                        isResetMode: true,
                        resetToken: this.state.password,
                        username: this.state.user || this.state.email // Pass the input user/email
                    }
                });
            } else {
                this.props.navigate(redirectTo);
            }
        };

        if (isResetPassword) {
            runNavigate();
            return;
        }

        const reduceMotion =
            typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion) {
            runNavigate();
            return;
        }

        const SWALLOW_MS = 1150;
        const REVEAL_MS = 950;

        this.setState({ loginExitActive: true, loginExitReveal: false }, () => {
            this._exitRevealTimer = window.setTimeout(() => {
                this.setState({ loginExitReveal: true });
            }, SWALLOW_MS);

            this._exitNavigateTimer = window.setTimeout(() => {
                if (this._exitRevealTimer != null) {
                    clearTimeout(this._exitRevealTimer);
                    this._exitRevealTimer = null;
                }
                runNavigate();
            }, SWALLOW_MS + REVEAL_MS);
        });
    }

    handleStartMfaSetup = () => {
        this.setState({ showSpinner: true });
        const { userId } = this.state.loginResponseData;
        const { user, password } = this.state;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: user,
            password: encryptPassword(password)
        };

        enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                this.setState({
                    codigoQR: res.codigoQrEnlace,
                    showMfaSetup: true,
                    showMfaPrompt: false,
                    showSpinner: false
                });
            })
            .catch(err => {
                toast.error("Error al iniciar configuración MFA");
                this.setState({ showSpinner: false });
            });
    }

    handleConfirmMfaSetup = () => {
        const { userId } = this.state.loginResponseData;
        const { mfaSetupCode } = this.state;

        if (!mfaSetupCode || mfaSetupCode.length !== 6) {
            this.setState({ mfaSetupError: "El código debe tener 6 dígitos" });
            return;
        }

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: mfaSetupCode,
        };

        this.setState({ showSpinner: true, mfaSetupError: "" });

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("MFA configurado correctamente");
                this.props.setMfaStatus(true, true);
                this.completeLogin(this.state.loginResponseData);
            })
            .catch((error) => {
                this.setState({
                    showSpinner: false,
                    mfaSetupError: "Código incorrecto. Intente nuevamente."
                });
            });
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    handleVerifyReCaptcha = (token) => {
        if (this.state.setTokenReCaptcha) {
            this.verifyReCaptcha(token);
        }
    }

    render() {
        const { showSpinner, recoverPassword, showInputMFaHabilitado, codigoDobleAutenticacion, showMfaPrompt, showMfaSetup, codigoQR, mfaSetupCode, mfaSetupError, loginExitActive, loginExitReveal, sellerLogo, sellerNombre } = this.state;
        const hasSellerBranding = Boolean(sellerNombre);

        const IconEye = (isHidden) => (
            <i className={`mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px`} />
        );

        const screenClass = [
            'login-screen',
            loginExitActive ? 'login-screen--exit' : '',
            loginExitReveal ? 'login-screen--reveal' : '',
        ].filter(Boolean).join(' ');

        return (
            <section className={screenClass}>
                {loginExitReveal ? (
                    <div className="login-screen__market-reveal" role="status" aria-live="polite">
                        <div className="login-screen__market-reveal-card">
                            {hasSellerBranding ? (
                                <>
                                    <span className="login-screen__market-reveal-eyebrow">Acceso confirmado</span>
                                    <div className="login-screen__market-reveal-store">
                                        {sellerLogo ? (
                                            <img
                                                className="login-screen__market-reveal-store-logo"
                                                src={sellerLogo}
                                                alt=""
                                            />
                                        ) : null}
                                        <h2 className="login-screen__market-reveal-title login-screen__market-reveal-title--store">
                                            {sellerNombre}
                                        </h2>
                                    </div>
                                    <p className="login-screen__market-reveal-text">Cargando tu Seller Center…</p>
                                </>
                            ) : (
                                <>
                                    <img
                                        className="login-screen__market-reveal-logo"
                                        src="/img/logo-marketplace-megatone.png"
                                        alt="Marketplace Megatone"
                                    />
                                    <span className="login-screen__market-reveal-eyebrow">Acceso confirmado</span>
                                    <h2 className="login-screen__market-reveal-title">Marketplace Megatone</h2>
                                    <p className="login-screen__market-reveal-text">Cargando tu Seller Center…</p>
                                </>
                            )}
                            <span className="login-screen__market-reveal-bar" aria-hidden="true" />
                        </div>
                    </div>
                ) : null}
                <div className="login-screen__stage" ref={this.loginStageRef}>
                    <div className="login-screen__ambient login-screen__ambient--primary" />
                    <div className="login-screen__ambient login-screen__ambient--secondary" />
                    <div className="login-shell row justify-content-center align-items-stretch g-0">
                    <div className="col-12 col-lg-4">
                        <div className="login-hero">
                            <span className="login-hero__badge">Marketplace Megatone</span>
                            <img className="login-hero__logo" src="/img/logo-marketplace-megatone.png" alt="Marketplace Megatone" />
                            
                            <h1 className="login-hero__title">
                                {recoverPassword ? "Recuperación de acceso" : "Acceso Seller Center"}
                            </h1>
                            <p className="login-hero__text">
                                {recoverPassword
                                    ? "Solicita una nueva clave temporal para retomar el acceso de forma segura."
                                    : "Ingresa con tus credenciales para operar publicaciones, órdenes, rebates, liquidaciones, todo desde un único lugar."}
                            </p>
                            <div className="login-hero__highlights">
                                <div className="login-hero__highlight">Acceso seguro</div>
                                <div className="login-hero__highlight">Operación centralizada</div>
                                <div className="login-hero__highlight">Soporte Doble Factor</div>
                            </div>
                        </div>
                    </div>

                    <div className="login-box card col-12 col-lg-8">
                        <div className="card-body login-box__body">
                            <form className="form-horizontal form-material login-form" id="loginform" onSubmit={this.handleFormSubmit}>

                                <div className="login-brand">
                          
                                    <div className="login-brand__copy">
                                        <span className="login-brand__eyebrow">Login Seller Center</span>
                                        <h2 className="login-brand__title">
                                            {recoverPassword
                                                ? "Solicitar nueva contraseña"
                                                : showMfaSetup
                                                    ? "Vincular autenticador"
                                                    : showMfaPrompt
                                                        ? "Activar doble factor"
                                                        : showInputMFaHabilitado
                                                            ? "Confirmar segundo factor"
                                                            : "Ingresar a la plataforma"}
                                        </h2>
                                        <p className="login-brand__subtitle">
                                            {recoverPassword
                                                ? "Ingresá el correo del usuario y enviamos un acceso temporal."
                                                : showMfaSetup
                                                    ? "Escaneá el código QR y validá el código para completar la configuración."
                                                    : showMfaPrompt
                                                        ? "Recomendamos activarlo ahora para proteger mejor tu cuenta."
                                                        : showInputMFaHabilitado
                                                            ? "Usá el código generado por tu aplicación de autenticación."
                                                            : "Accedé con tus credenciales para continuar."}
                                        </p>
                                    </div>
                                </div>

                                {!recoverPassword ?
                                    <div className="login-form__content">
                                        {/* MFA Prompt UI */}
                                        {showMfaPrompt ? (
                                            <div className="text-center">
                                                <h4 className="mb-3">Configuración de Doble Factor</h4>
                                                <p>Para mejorar la seguridad de tu cuenta, te recomendamos activar el doble factor de autenticación.</p>

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100 mb-2"
                                                    onClick={this.handleStartMfaSetup}
                                                >
                                                    Configurar ahora
                                                </button>

                                                <a
                                                    href="/manual_mfa.html"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary w-100 mb-2"
                                                >
                                                    <i className="mdi mdi-help-circle-outline me-1"></i>
                                                    Ayuda para configurar
                                                </a>
                                            </div>
                                        ) : showMfaSetup ? (
                                            <div className="text-center">
                                                <h5 className="mb-3">Escaneá el código QR</h5>
                                                {codigoQR && (
                                                    <img
                                                        src={`data:image/png;base64,${codigoQR}`}
                                                        alt="QR de autenticación"
                                                        style={{ width: 200, height: 200 }}
                                                        className="mb-3"
                                                    />
                                                )}
                                                <p className="small text-muted">
                                                    Usá una app como Microsoft Authenticator o Google Authenticator.
                                                </p>

                                                <input
                                                    required
                                                    name="mfaSetupCode"
                                                    type="text"
                                                    className="form-control mb-3 text-center"
                                                    placeholder="Ingresá el código de 6 dígitos"
                                                    onChange={this.handleChange}
                                                    maxLength={6}
                                                    value={mfaSetupCode}
                                                />
                                                {mfaSetupError && <small className="text-danger d-block mb-2">{mfaSetupError}</small>}

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100"
                                                    onClick={this.handleConfirmMfaSetup}
                                                >
                                                    Confirmar
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-link w-100 mt-2"
                                                    onClick={() => this.setState({ showMfaSetup: false, showMfaPrompt: true })}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        ) : (
                                            // Normal Login UI
                                            <>
                                                <div className="form-group">
                                                    <div className="col-12">
                                                        <label className="login-form__label">Usuario</label>
                                                        <input
                                                            required
                                                            name="user"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Ingresa tu usuario"
                                                            onChange={this.handleChange}
                                                            value={this.state.user}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label className="login-form__label">Contraseña</label>
                                                    <div className="input-group">
                                                        <input
                                                            required
                                                            name="password"
                                                            type={this.state.showPassword ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Ingresa tu contraseña"
                                                            onChange={this.handleChange}
                                                            value={this.state.password}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            onClick={this.togglePasswordVisibility}
                                                        >
                                                            {IconEye(this.state.showPassword)}
                                                        </button>
                                                    </div>
                                                </div>

                                                {showInputMFaHabilitado && (
                                                    <div className="form-group">
                                                        <div className="col-12">
                                                            <label className="login-form__label">Código de autenticación</label>
                                                            <input
                                                                required
                                                                name="codigoDobleAutenticacion"
                                                                type="text"
                                                                className={`form-control ${this.state.errorCodigoMfa ? "is-invalid" : ""}`}
                                                                placeholder="Ingresá el código de 6 dígitos"
                                                                onChange={this.handleChange}
                                                                maxLength={6}
                                                                value={codigoDobleAutenticacion}
                                                            />
                                                            {this.state.errorCodigoDobleAutenticacion && (
                                                                <small className="text-danger">{this.state.errorCodigoDobleAutenticacion}</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {this._SolveReCaptcha && Boolean(this.props.googleReCaptchaProps?.executeRecaptcha) &&
                                                    <GoogleReCaptcha
                                                        onVerify={this.handleVerifyReCaptcha}
                                                    />
                                                }

                                                <div className="form-group text-center">
                                                    {(showSpinner) ? (
                                                        <div className="login-in-progress" role="status" aria-live="polite">
                                                            <span className="login-in-progress__text">Login en proceso</span>
                                                        </div>
                                                    ) :
                                                        <div>
                                                            <div className="d-block mt-3">
                                                                <button
                                                                    onClick={this.onLogin}
                                                                    className="btn btn-block background-rojo-megatone w-75"
                                                                    type="submit"
                                                                >
                                                                    Entrar
                                                                </button>
                                                            </div>

                                                            <div className="d-block mt-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.setState({ recoverPassword: true })}
                                                                    className="btn btn-link w-75"
                                                                >
                                                                    Recuperar contraseña
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                            </>
                                        )}
                                    </div>

                                    :

                                    <div className="login-recovery-card">
                                        <div className="form-group">
                                            <div className="col-12">
                                                <label className="login-form__label">Email del usuario</label>
                                                <input
                                                    required
                                                    name="email"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email del usuario"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group p-1 text-center">
                                            <div className="col-12">
                                                {showSpinner ? (
                                                    <div className="login-in-progress" role="status" aria-live="polite">
                                                        <span className="login-in-progress__text">Enviando solicitud</span>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={this.onRequestToken}
                                                        className="btn btn-block btn-large background-rojo-megatone rounded-sm"
                                                    >
                                                        Solicitar nueva contraseña
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text-center mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm"
                                                onClick={() => this.setState({ recoverPassword: false })}
                                            >
                                                Volver al inicio de sesión
                                            </button>
                                        </div>

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="login-screen__journey" aria-hidden="true">
                    <div className="login-screen__journey-surface" />
                    <div className="login-screen__journey-track" />
                    <svg
                        className="login-screen__journey-wave"
                        viewBox="0 0 1200 56"
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                        role="presentation"
                    >
                        <defs>
                            <linearGradient id="login-journey-wave-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#d1161f" stopOpacity="0.55" />
                                <stop offset="35%" stopColor="#0d6b6b" stopOpacity="0.5" />
                                <stop offset="70%" stopColor="#3a2f6b" stopOpacity="0.48" />
                                <stop offset="100%" stopColor="#d1161f" stopOpacity="0.45" />
                            </linearGradient>
                        </defs>
                        <path
                            className="login-screen__journey-rail"
                            d="M0,34 C180,12 360,48 540,26 C720,6 900,44 1080,22 C1140,16 1180,28 1200,30"
                        />
                        <path
                            className="login-screen__journey-rail-dash"
                            d="M0,34 C180,12 360,48 540,26 C720,6 900,44 1080,22 C1140,16 1180,28 1200,30"
                        />
                    </svg>
                    <div className="login-screen__journey-goals">
                        <span className="login-screen__goal login-screen__goal--a" title="Pedidos">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
                                <path d="M8 8V6a2 2 0 012-2h4a2 2 0 012 2v2M5 8h14l-1 14H6L5 8z" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span className="login-screen__goal login-screen__goal--b" title="Publicaciones">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
                                <path d="M4 6h16v12H4zM8 6V5a2 2 0 012-2h4a2 2 0 012 2v1" />
                                <path d="M8 11h8" />
                            </svg>
                        </span>
                        <span className="login-screen__goal login-screen__goal--c" title="Liquidaciones">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
                                <circle cx="12" cy="12" r="8" />
                                <path d="M12 8v4l3 2" strokeLinecap="round" />
                            </svg>
                        </span>
                        <span className="login-screen__goal login-screen__goal--d" title="Métricas">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
                                <path d="M4 18V6M10 18v-5M16 18V9M22 18V3" strokeLinecap="round" />
                            </svg>
                        </span>
                    </div>
                    <div className="login-screen__journey-cart-wrap">
                        <span className="login-screen__cart-trail" />
                        <span className="login-screen__cart-glow" />
                        <span className="login-screen__cart-suck-ring" />
                    <div className="login-screen__journey-cart">
                        <svg
                            className="login-screen__pro-cart"
                            viewBox="0 0 120 100"
                            xmlns="http://www.w3.org/2000/svg"
                            role="presentation"
                        >
                            <defs>
                                <linearGradient id="login-pro-cart-metal" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#8b929a" />
                                    <stop offset="100%" stopColor="#4a5158" />
                                </linearGradient>
                                <linearGradient id="login-pro-cart-basket" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#fafbfc" />
                                    <stop offset="100%" stopColor="#e8eaed" />
                                </linearGradient>
                                <filter id="login-pro-cart-soft" x="-15%" y="-15%" width="130%" height="130%">
                                    <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#1a1214" floodOpacity="0.18" />
                                </filter>
                            </defs>
                            <ellipse cx="60" cy="96" rx="36" ry="3" fill="#1a1214" fillOpacity="0.08" />
                            <g className="login-screen__pro-cart-wheel login-screen__pro-cart-wheel--l">
                                <circle cx="28" cy="80" r="8" fill="#2a2d30" stroke="#141618" strokeWidth="1.5" />
                                <circle cx="28" cy="80" r="2.8" fill="#6d7379" />
                            </g>
                            <g className="login-screen__pro-cart-wheel login-screen__pro-cart-wheel--r">
                                <circle cx="92" cy="80" r="8" fill="#2a2d30" stroke="#141618" strokeWidth="1.5" />
                                <circle cx="92" cy="80" r="2.8" fill="#6d7379" />
                            </g>
                            <g filter="url(#login-pro-cart-soft)">
                                <path
                                    d="M14 74 H106"
                                    fill="none"
                                    stroke="url(#login-pro-cart-metal)"
                                    strokeWidth="3.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M14 36 V20 C14 12 20 8 28 8 H50 C58 8 62 12 62 18 V34"
                                    fill="none"
                                    stroke="url(#login-pro-cart-metal)"
                                    strokeWidth="3.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M62 34 H70"
                                    fill="none"
                                    stroke="url(#login-pro-cart-metal)"
                                    strokeWidth="3.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M24 36 H94 L100 68 H30 L24 36 Z"
                                    fill="url(#login-pro-cart-basket)"
                                    stroke="#9aa0a8"
                                    strokeWidth="1.8"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M24 36 H94 M28 44 H96 M30 52 H98 M32 60 H100"
                                    fill="none"
                                    stroke="#c8cdd3"
                                    strokeWidth="1.1"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M38 36 V68 M54 36 V68 M70 36 V68 M86 36 V68"
                                    fill="none"
                                    stroke="#d5dae0"
                                    strokeWidth="0.9"
                                    strokeLinecap="round"
                                />
                                <g className="login-screen__cart-mega-badge" transform="translate(44, 40)">
                                    <rect width="34" height="26" rx="4" fill="#ffffff" stroke="#dfe2e6" strokeWidth="0.9" />
                                    <svg
                                        className="login-screen__cart-mega-m"
                                        x="3"
                                        y="3"
                                        width="28"
                                        height="20"
                                        viewBox="0 0 4284 3895"
                                        preserveAspectRatio="xMidYMid meet"
                                        role="presentation"
                                    >
                                        <path
                                            fill="#E53308"
                                            d="M4284 386c0,-104 -76,-189 -175,-205 -455,-87 -1111,-181 -1967,-181 -676,0 -1336,63 -1977,184 -94,20 -165,103 -165,203 0,24 4,47 12,68 158,439 344,865 555,1275l189 -1000 1074 0 156 978c8,46 62,43 86,5l517 -983 1081 0 -310 1638c364,-600 670,-1239 911,-1909l-1 0c9,-23 14,-47 14,-72zm-1534 1144c6,-31 -43,-46 -67,-5l-642 1233c-39,66 -106,64 -106,64l-347 1c0,0 -73,2 -84,-71l-188 -1232c-9,-51 -63,-47 -72,0l-201 1038c285,448 603,875 950,1274l0 0c38,39 91,62 149,62 58,0 110,-23 148,-62l0 0c279,-321 538,-659 778,-1012l-564 2 246 -1292z"
                                        />
                                        <path
                                            fill="#ffffff"
                                            d="M567 1730l476 829 201 -1038c10,-47 64,-51 72,0l188 1232c11,72 84,71 84,71l347 -1c0,0 67,2 106,-64l642 -1233c23,-41 73,-26 67,5l-246 1292 563 -2 292 -455 310 -1637 -1081 0 -517 983c-24,37 -78,41 -86,-5l-156 -978 -1074 0 -189 1000 0 0z"
                                        />
                                    </svg>
                                </g>
                            </g>
                        </svg>
                    </div>
                    </div>
                </div>
            </section>
        )
    }
}


// Wrapper para usar hooks en class component y el Provider de ReCaptcha
const LoginWithRecaptcha = withGoogleReCaptcha(Login);

const LoginWrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <LoginWithRecaptcha {...props} navigate={navigate} location={location} />;
};

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId
});

// Exportar versión sin reCAPTCHA para fallback cuando no hay Provider
export const LoginBase = connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(Login);

export default connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(LoginWrapper);
